import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import ApolloWrapper from "components/ApolloWrapper";
import Layout from "components/Layout";
import PageNotFoud from "components/PageNotFoud";
import Provider from "components/Provider";
import Home from "pages/Home";
import { ContextProvider } from "./context";

function App() {
  return (
    <Router>
      <ContextProvider>
        <ApolloWrapper>
          <Provider>
            <Layout>
              <Switch>
                <Route path="/" component={Home} exact={true} />
                <Route component={PageNotFoud} />
              </Switch>
            </Layout>
          </Provider>
        </ApolloWrapper>
      </ContextProvider>
    </Router>
  );
}

export default App;
